import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  ListGroup,
  Image,
  Carousel,
  Badge,
  Spinner,
  Tab,
  Nav,
  Table,
  Modal,
  Breadcrumb,
  InputGroup,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import constusbanner from "../../Assests/back-header-1.png";

import {
  FaHeart,
  FaShare,
  FaCommentDots,
  FaMap,
  FaBed,
  FaBath,
  FaRulerCombined,
  FaCalendarAlt,
  FaClock,
  FaDollarSign,
  FaRegHeart,
} from "react-icons/fa";

function PropertyDetails() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { listingKey } = useParams();
  const [property, setProperty] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDateTimeFields, setShowDateTimeFields] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);

  const [showCarousel, setShowCarousel] = useState(false);

  const handleCarouselSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const openCarousel = () => {
    setShowCarousel(true);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    scheduleViewing: false,
    preferredDate: "",
    preferredTime: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (name === "scheduleViewing") {
      setShowDateTimeFields(checked);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "https://handarealtor.ca/send-email",
        formData,
      );
      alert("Your request has been sent!");
      console.log(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to send the request.");
    }
  };

  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const res = await axios.get(
          `https://handarealtor.ca/property-details/${listingKey}`,
        );
        setProperty(res.data);
      } catch (err) {
        console.error("Error fetching property details", err);
      }

      try {
        const imgRes = await axios.get(
          `https://handarealtor.ca/property-images/${listingKey}`,
        );
        setImages(imgRes.data.images || []);
      } catch (err) {
        console.error("Error fetching images", err);
      }

      setLoading(false);
    };

    fetchProperty();
  }, [listingKey]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const toggleDateTimeFields = () => {
    setShowDateTimeFields(!showDateTimeFields);
  };

  const toggleFavorite = () => {
    setIsFavorite(!isFavorite);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-white">
        <Spinner animation="border" variant="dark" />
        <span className="ms-2">Loading property details...</span>
      </div>
    );
  }

  if (!property) {
    return (
      <Container fluid className="py-5 text-center">
        <div className="alert alert-warning">
          <h4>Property Not Found</h4>
          <p>
            We couldn't find the property you're looking for. Please check the
            listing ID and try again.
          </p>
        </div>
      </Container>
    );
  }

  return (
    <>
      <section
        className="contact-banner d-flex align-items-center justify-content-center text-center text-white"
        style={{
          backgroundImage: `url(${constusbanner})`,
        }}
      >
        <div className="overlay"></div>

        <div className="content w-100 container pt-5">
          <h1 className="text-start banner-title">Properties Details</h1>
        </div>
      </section>
      <Container className="py-5">
        {/* Header Section */}
        {/* <Card className="shadow-sm border-0 mb-4">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={8}>
                <div className="d-flex align-items-center mb-2">
                  <Badge bg="warning" text="dark" className="me-2 px-3 py-2">
                    {property?.TransactionType || "For Sale"}
                  </Badge>
                  <small className="text-muted">
                    Listed on {property?.ModificationTimestamp || "N/A"}
                  </small>
                </div>
                <h2 className="fw-bold mb-1">{property?.UnparsedAddress || "Property Address"}</h2>
                <p className="text-muted mb-2">
                  {property?.city || "West Taylor"}, {property?.neighborhood || "Rhode Island"}
                </p>
              </Col>
              <Col lg={4} className="text-lg-end mt-3 mt-lg-0">
                <h3 className="text-dark fw-bold mb-0">
                  ${property?.ListPrice?.toLocaleString() || "308,085"}
                </h3>
              </Col>
            </Row>
          </Card.Body>
        </Card> */}

        <Row className="mb-4 align-items-center">
          <Col xs={12} className="">
            <Breadcrumb>
              <Breadcrumb.Item href="/">
                <span className="text-dark">Home</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>
                {property?.city || "West Taylor"},{" "}
                {property?.neighborhood || "Rhode Island"}
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>

          <Col xs={12} md={12} className="text-center">
            <p
              className="fw-semibold mb-2 mb-md-0"
              style={{ fontSize: "1.5rem" }}
            >
              {property?.ListingKey}
            </p>
          </Col>
        </Row>

        {/* Image Gallery */}
        <Card className="shadow-sm border-0 mb-4 overflow-hidden">
          {images.length > 0 ? (
            <>
              <Row className="g-2">
                <Col md={8}>
                  <div className="property-image" style={{ height: "508px" }}>
                    <Image
                      src={images[0]}
                      alt="Main Property Image"
                      className="d-block w-100 h-100 "
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                </Col>

                <Col md={4}>
                  <Row className="g-2">
                    <Col xs={12}>
                      <div
                        className="property-image"
                        style={{ height: "250px" }}
                      >
                        <Image
                          src={images.length > 1 ? images[1] : images[0]}
                          alt="Property Image 2"
                          className="d-block w-100 h-100"
                          style={{ objectFit: "cover" }}
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div
                        className="property-image"
                        style={{ height: "250px" }}
                      >
                        {images.length > 2 ? (
                          <Image
                            src={images[2]}
                            alt="Property Image 3"
                            className="d-block w-100 h-100"
                            style={{ objectFit: "cover" }}
                          />
                        ) : (
                          <div className="d-flex justify-content-center align-items-center h-100 bg-light">
                            <p className="text-muted">No additional image</p>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* See more images button */}
              <div className="position-relative">
                <Button
                  variant="light"
                  className="position-absolute end-0 bottom-0 m-3 shadow-sm"
                  onClick={openCarousel}
                >
                  <i className="bi bi-images me-2"></i> Tap here to see more
                  images
                </Button>
              </div>
            </>
          ) : (
            <div className="text-center py-5">
              <p className="text-muted">
                No images available for this property
              </p>
            </div>
          )}
        </Card>

        {/* Modal with Carousel for viewing all images */}
        <Modal
          show={showCarousel}
          onHide={() => setShowCarousel(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {property?.UnparsedAddress || "Property Address"} Images
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <Carousel
              activeIndex={activeIndex}
              onSelect={handleCarouselSelect}
              indicators={true}
              interval={null}
            >
              {images.map((image, index) => (
                <Carousel.Item key={index}>
                  <div style={{ height: "600px", background: "#f8f9fa" }}>
                    <Image
                      src={image}
                      alt={`Property Image ${index + 1}`}
                      className="d-block w-100 h-100"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                  <Carousel.Caption>
                    <h6 className="bg-dark bg-opacity-50 p-2 rounded">
                      Image {index + 1} of {images.length}
                    </h6>
                  </Carousel.Caption>
                </Carousel.Item>
              ))}
            </Carousel>
          </Modal.Body>
        </Modal>

        <Row>
          {/* Main Content */}
          <Col lg={8}>
            {/* Property Highlights */}
            <Card className="shadow-sm border-0 mb-4 rounded">
              <Card.Body className="p-4 position-relative">
                {/* Favourite Icon (top-right corner) */}
                <div className="position-absolute top-0 end-0 p-2">
                  <button
                    onClick={toggleFavorite}
                    className="btn border-0 bg-transparent shadow-none"
                    style={{ fontSize: "1.5rem" }}
                  >
                    {isFavorite ? (
                      <FaHeart className="text-danger" />
                    ) : (
                      <FaRegHeart className="text-muted" />
                    )}
                  </button>
                </div>

                {/* Price */}
                <Badge className="property-status-badge px-3 py-2 mb-2">
                  {property.StandardStatus}
                </Badge>

                <h2 className="mb-3 listingPriceValue">
                  ${property.ListPrice?.toLocaleString()}
                </h2>

                {/* Address */}
                <h5 className="mb-1">{property?.StreetAddress}</h5>
                <p className="text-muted mb-2">
                  {property?.City}, {property?.Province} {property?.PostalCode}
                </p>

                {/* MLS Number */}
                <p className="small text-muted mb-4">
                  MLS® Number:{" "}
                  {property?.ListingId ? property?.ListingId : "N/A"}
                </p>

                {/* Row with Mortgage CTA + Bed/Bath/Sq Ft */}
                <div className="d-flex justify-content-between align-items-center border-top pt-3 mt-3 flex-wrap gap-3">
                  {/* Get Qualified Link */}
                  <a
                    href="#"
                    className="text-decoration-none d-inline-flex align-items-center text-dark"
                  >
                    <FaDollarSign className="me-2" />
                    Get Qualified for a Mortgage
                  </a>

                  {/* Property Stats */}
                  <div className="d-flex align-items-center gap-4 text-muted">
                    <div className="d-flex align-items-center gap-1">
                      <FaBed />
                      <span>{property?.BedroomsTotal || 0} Beds</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <FaBath />
                      <span>{property?.BathroomsTotalInteger || 0} Baths</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <FaRulerCombined />
                      <span>{property?.BuildingAreaTotal || 0} Sq Ft</span>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>

            {/* Tabbed Information */}
            {/* Tabbed Information */}
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body className="p-0">
                <Tab.Container defaultActiveKey="highlights">
                  <Nav variant="tabs" className="nav-fill border-bottom">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="highlights"
                        className="py-3 text-dark fw-semibold"
                      >
                        Highlights
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link
                        eventKey="details"
                        className="py-3 text-dark fw-semibold"
                      >
                        Property Details
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="features"
                        className="py-3 text-dark fw-semibold"
                      >
                        Features
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="neighborhood"
                        className="py-3 text-dark fw-semibold"
                      >
                        Neighborhood
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="statistics"
                        className="py-3 text-dark fw-semibold"
                      >
                        Statistics
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="calculators"
                        className="py-3 text-dark fw-semibold"
                      >
                        Calculators
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    {/* Highlights Tab */}
                    <Tab.Pane eventKey="highlights" className="p-4">
                      <h4 className="fw-bold mb-3">Listing Description</h4>
                      <p> {property.TaxLegalDescription}</p>
                      <h4 className="fw-bold mb-3">Property Summary</h4>
                      <Row className="mb-4">
                        <Col md={12}>
                          <div className="mb-4">
                            <h5 className="fw-bold text-dark mb-3">
                              Key Features
                            </h5>
                            <Row className="gy-4">
                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">Property Type</p>
                                <p className="mb-0">
                                  {property.PropertyType || "N/A"}
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">Building Type</p>
                                <p className="mb-0">
                                  {property.BuildingType || "N/A"}
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">Storeys</p>
                                <p className="mb-0">
                                  {property.NumberOfStories || "N/A"}
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">Square Footage</p>
                                <p className="mb-0">
                                  {property.BuildingAreaTotal || "N/A"} sqft
                                  <sup>2</sup>
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">
                                  Neighbourhood Name
                                </p>
                                <p className="mb-0">
                                  {property.Neighbourhood || "N/A"}
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">Title</p>
                                <p className="mb-0">
                                  {property.Title || "N/A"}
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">Land Size</p>
                                <p className="mb-0">
                                  {property.LotSizeSquareFeet || "N/A"} m
                                  <sup>2</sup>
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">Built in</p>
                                <p className="mb-0">
                                  {property.YearBuilt || "N/A"}
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">Parking Type</p>
                                <p className="mb-0">
                                  {property.ParkingFeatures || "N/A"}
                                </p>
                              </Col>

                              <Col xs={12} sm={6} md={3}>
                                <p className="mb-0 fw-bold">
                                  Time on REALTOR.ca
                                </p>
                                <p className="mb-0">
                                  {property.StandardStatus || "N/A"}
                                </p>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        {/* <Col md={6}>
              <h5 className="fw-bold text-dark mb-3">Notable Amenities</h5>
              <div className="bg-light p-4 rounded">
                <ul className="list-unstyled mb-0">
                  {property.Appliances && (
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      {property.Appliances ? property.Appliances : "N/A"}
                    </li>
                  )}
                  {property.Cooling && (
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      {property.Cooling}
                    </li>
                  )}
                  {property.ExteriorFeatures && (
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      {property.ExteriorFeatures}
                    </li>
                  )}
                  {property.GreenEnergyEfficient && (
                    <li>
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Energy Efficient: {property.GreenEnergyEfficient}
                    </li>
                  )}
                </ul>
              </div>
            </Col> */}
                      </Row>
                    </Tab.Pane>

                    {/* Property Details Tab */}
                    <Tab.Pane eventKey="details" className="p-4">
                      <h4 className="fw-bold mb-3">Property Details</h4>
                      <Row>
                        <Col md={6}>
                          <Table borderless className="table-sm">
                            <tbody>
                              <tr>
                                <td className="text-muted">Property Type</td>
                                <td className="fw-bold text-end">
                                  {property.PropertyType}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Lot Size</td>
                                <td className="fw-bold text-end">
                                  {property.LotSizeSquareFeet} sqft
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Parking</td>
                                <td className="fw-bold text-end">
                                  {property.ParkingTotal} spaces
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Year Built</td>
                                <td className="fw-bold text-end">
                                  {property.YearBuilt || "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Status</td>
                                <td className="fw-bold text-end">
                                  {property.StandardStatus}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Annual Tax</td>
                                <td className="fw-bold text-end">
                                  {property.TaxAnnualAmount}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Garage Spaces</td>
                                <td className="fw-bold text-end">
                                  {property.GarageSpaces || "N/A"}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                        <Col md={6}>
                          <Table borderless className="table-sm">
                            <tbody>
                              <tr>
                                <td className="text-muted">City</td>
                                <td className="fw-bold text-end">
                                  {property.City ? property.City : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">
                                  Property Attached
                                </td>
                                <td className="fw-bold text-end">
                                  {property.PropertyAttachedYN
                                    ? property.PropertyAttachedYN
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Levels</td>
                                <td className="fw-bold text-end">
                                  {property.Levels ? property.Levels : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">High School</td>
                                <td className="fw-bold text-end">
                                  {property.HighSchool
                                    ? property.HighSchool
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">City Regionl</td>
                                <td className="fw-bold text-end">
                                  {property.CityRegion
                                    ? property.CityRegion
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Frontage Length</td>
                                <td className="fw-bold text-end">
                                  {property.FrontageLength
                                    ? property.FrontageLength
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-muted">Possession Type</td>
                                <td className="fw-bold text-end">
                                  {property.PossessionType
                                    ? property.PossessionType
                                    : "N/A"}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </Tab.Pane>

                    {/* Features Tab */}
                    <Tab.Pane eventKey="features" className="p-4">
                      <h4 className="fw-bold mb-3">Property Features</h4>
                      <Row className="mb-4">
                        <Col md={6}>
                          <h5 className="fw-bold text-dark mb-3">
                            Interior Features
                          </h5>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">Appliances</span>
                              <span className="fw-bold text-end">
                                {property.Appliances
                                  ? property.Appliances
                                  : "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">Heating</span>
                              <span className="fw-bold text-end">
                                {property.Heating ? property.Heating : "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">Cooling</span>
                              <span className="fw-bold text-end">
                                {property.Cooling ? property.Cooling : "N/A"}
                              </span>
                            </li>
                          </ul>
                        </Col>
                        <Col md={6}>
                          <h5 className="fw-bold text-dark mb-3">
                            Exterior Features
                          </h5>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">
                                Exterior Features
                              </span>
                              <span className="fw-bold text-end">
                                {property.ExteriorFeatures &&
                                property.ExteriorFeatures !== ""
                                  ? property.ExteriorFeatures
                                  : "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">Roof</span>
                              <span className="fw-bold text-end">
                                {property.Roof && property.Roof !== ""
                                  ? property.Roof
                                  : "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">Pool Features</span>
                              <span className="fw-bold text-end">
                                {property.PoolFeatures &&
                                property.PoolFeatures !== ""
                                  ? property.PoolFeatures
                                  : "N/A"}
                              </span>
                            </li>
                          </ul>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <h5 className="fw-bold text-dark mb-3">
                            Construction
                          </h5>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">
                                Construction Materials
                              </span>
                              <span className="fw-bold text-end">
                                {property.ConstructionMaterials
                                  ? property.ConstructionMaterials
                                  : "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">
                                Foundation Details
                              </span>
                              <span className="fw-bold text-end">
                                {property.FoundationDetails
                                  ? property.FoundationDetails
                                  : "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">
                                Energy Efficient
                              </span>
                              <span className="fw-bold text-end">
                                {property.GreenEnergyEfficient
                                  ? property.GreenEnergyEfficient
                                  : "N/A"}
                              </span>
                            </li>
                          </ul>
                        </Col>
                        <Col md={6}>
                          <h5 className="fw-bold text-dark mb-3">Utilities</h5>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">Water Source</span>
                              <span className="fw-bold text-end">N/A</span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">Sewer</span>
                              <span className="fw-bold text-end">
                                {property.Sewer ? property.Sewer : "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">
                                Road Surface Type
                              </span>
                              <span className="fw-bold text-end">
                                {property.RoadSurfaceType
                                  ? property.RoadSurfaceType
                                  : "N/A"}
                              </span>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                    </Tab.Pane>

                    {/* Neighborhood Tab with Map */}
                    <Tab.Pane eventKey="neighborhood" className="p-4">
                      <h4 className="fw-bold mb-3">Neighborhood</h4>
                      <Row>
                        <Col md={12} className="mb-4">
                          {/* Map Container */}
                          <div
                            className="position-relative rounded overflow-hidden"
                            style={{ height: "400px" }}
                          >
                            <iframe
                              title="Property Location"
                              allowFullScreen
                              loading="lazy"
                              src={`https://www.google.com/maps?q=${
                                property.Latitude || 33.955692
                              },${
                                property.Longitude || -118.077872
                              }&output=embed`}
                              style={{
                                border: 0,
                                width: "100%",
                                height: "100%",
                                borderRadius: "0.5rem",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <h5 className="fw-bold text-dark mb-3">
                            Location Details
                          </h5>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">
                                School District
                              </span>
                              <span className="fw-bold text-end">
                                {property.HighSchool || "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">City</span>
                              <span className="fw-bold text-end">
                                {property.City || "N/A"}
                              </span>
                            </li>
                            <li className="list-group-item px-0 d-flex justify-content-between">
                              <span className="text-muted">County</span>
                              <span className="fw-bold text-end">
                                {property.CountyOrParish || "N/A"}
                              </span>
                            </li>
                          </ul>
                        </Col>
                        <Col md={6}>
                          <h5 className="fw-bold text-dark mb-3">
                            Nearby Amenities
                          </h5>
                          <div className="p-3 bg-light rounded">
                            <div className="mb-2">
                              <p className="mb-1">
                                <i className="bi bi-shop me-2 text-dark"></i>
                                <strong>Shopping:</strong>{" "}
                                {property.ShoppingDistance
                                  ? `${property.ShoppingDistance} miles`
                                  : "N/A"}
                              </p>
                            </div>
                            <div className="mb-2">
                              <p className="mb-1">
                                <i className="bi bi-book me-2 text-dark"></i>
                                <strong>Schools:</strong>{" "}
                                {property.SchoolDistance
                                  ? `${property.SchoolDistance} miles`
                                  : "N/A"}
                              </p>
                            </div>
                            <div className="mb-2">
                              <p className="mb-1">
                                <i className="bi bi-hospital me-2 text-dark"></i>
                                <strong>Healthcare:</strong>{" "}
                                {property.HealthcareDistance
                                  ? `${property.HealthcareDistance} miles`
                                  : "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="mb-0">
                                <i className="bi bi-tree me-2 text-dark"></i>
                                <strong>Parks:</strong>{" "}
                                {property.ParkDistance
                                  ? `${property.ParkDistance} miles`
                                  : "N/A"}
                              </p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>

                    {/* Statistics Tab */}
                    <Tab.Pane eventKey="statistics" className="p-4">
                      <h4 className="fw-bold mb-3">Property Statistics</h4>
                      <Row>
                        <Col md={12}>
                          <h5 className="fw-bold text-dark mb-3">
                            Key Metrics
                          </h5>
                          <div className="table-responsive">
                            <Table className="table-striped">
                              <thead>
                                <tr>
                                  <th>Metric</th>
                                  <th>This Property</th>
                                  <th>Neighborhood Avg</th>
                                  <th>City Avg</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Price per Sq Ft</td>
                                  <td>
                                    $
                                    {property.ListPrice &&
                                    property.LotSizeSquareFeet
                                      ? Math.round(
                                          property.ListPrice /
                                            property.LotSizeSquareFeet,
                                        )
                                      : "N/A"}
                                  </td>
                                  <td>$225</td>
                                  <td>$198</td>
                                </tr>
                                <tr>
                                  <td>Days on Market</td>
                                  <td>{property.DaysOnMarket || "N/A"}</td>
                                  <td>45</td>
                                  <td>62</td>
                                </tr>
                                <tr>
                                  <td>Appreciation (5yr)</td>
                                  <td>12.4%</td>
                                  <td>10.2%</td>
                                  <td>8.7%</td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>

                    {/* Calculators Tab */}
                    <Tab.Pane eventKey="calculators" className="p-4">
                      <h4 className="fw-bold mb-3">Financial Calculators</h4>
                      <Row>
                        {/* Mortgage Calculator */}
                        <Col md={6} className="mb-4">
                          <div className="card h-100">
                            <div className="card-header bg-dark text-white">
                              <h5 className="mb-0">Mortgage Calculator</h5>
                            </div>
                            <div className="card-body">
                              <Form>
                                <Form.Group className="mb-3">
                                  <Form.Label>Home Price</Form.Label>
                                  <p className="fw-bold">
                                    $
                                    {property.ListPrice
                                      ? property.ListPrice
                                      : "N/A"}
                                  </p>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Down Payment (20%)</Form.Label>
                                  <p className="fw-bold">
                                    $
                                    {property.ListPrice
                                      ? Math.round(property.ListPrice * 0.2)
                                      : "N/A"}
                                  </p>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Interest Rate (%)</Form.Label>
                                  <p className="fw-bold">4.5%</p>
                                </Form.Group>
                                {/* <Button variant="dark" className="w-100">
              Calculate
            </Button> */}
                              </Form>
                            </div>
                          </div>
                        </Col>

                        {/* Affordability Calculator */}
                        <Col md={6} className="mb-4">
                          <div className="card h-100">
                            <div className="card-header bg-dark text-white">
                              <h5 className="mb-0">Affordability Calculator</h5>
                            </div>
                            <div className="card-body">
                              <Form>
                                <Form.Group className="mb-3">
                                  <Form.Label>Annual Income</Form.Label>
                                  <p className="fw-bold">
                                    $
                                    {property.TaxAnnualAmount
                                      ? property.TaxAnnualAmount * 10
                                      : "N/A"}
                                  </p>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Monthly Debt Payments</Form.Label>
                                  <p className="fw-bold">$500</p>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Down Payment</Form.Label>
                                  <p className="fw-bold">$70,000</p>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Interest Rate (%)</Form.Label>
                                  <p className="fw-bold">4.5%</p>
                                </Form.Group>
                                {/* <Button variant="dark" className="w-100">
              Calculate
            </Button> */}
                              </Form>
                              <div className="mt-3 p-3 bg-light rounded">
                                <p className="mb-1 fw-bold">
                                  Affordable Home Price:
                                </p>
                                <h4 className="text-dark">$412,000</h4>
                                <div
                                  className="progress mt-2"
                                  style={{ height: "10px" }}
                                >
                                  <div
                                    className="progress-bar bg-success"
                                    role="progressbar"
                                    style={{
                                      width:
                                        ((property.ListPrice || 350000) /
                                          412000) *
                                          100 +
                                        "%",
                                    }}
                                    aria-valuenow={
                                      ((property.ListPrice || 350000) /
                                        412000) *
                                      100
                                    }
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  ></div>
                                </div>
                                <small className="text-muted">
                                  This property is within your budget
                                </small>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {/* Total Cost of Ownership */}
                      <Row>
                        <Col md={12}>
                          <div className="card">
                            <div className="card-header bg-dark text-white">
                              <h5 className="mb-0">Total Cost of Ownership</h5>
                            </div>
                            <div className="card-body">
                              <Row>
                                <Col md={6}>
                                  <Form>
                                    <Form.Group className="mb-3">
                                      <Form.Label>
                                        Property Tax (annual)
                                      </Form.Label>
                                      <p className="fw-bold">
                                        ${property.TaxAnnualAmount || 3600}
                                      </p>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                      <Form.Label>
                                        Insurance (annual)
                                      </Form.Label>
                                      <p className="fw-bold">$1200</p>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                      <Form.Label>
                                        HOA Fees (monthly)
                                      </Form.Label>
                                      <p className="fw-bold">
                                        ${property.AssociationFee || 0}
                                      </p>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                      <Form.Label>
                                        Utilities (monthly)
                                      </Form.Label>
                                      <p className="fw-bold">$250</p>
                                    </Form.Group>
                                  </Form>
                                </Col>
                                <Col md={6}>
                                  <div className="bg-light p-3 rounded h-100">
                                    <h5 className="text-dark mb-3">
                                      Monthly Breakdown
                                    </h5>
                                    <ul className="list-group list-group-flush">
                                      <li className="list-group-item px-0 d-flex justify-content-between">
                                        <span>Mortgage Payment</span>
                                        <span className="fw-bold">
                                          $1,425.00
                                        </span>
                                      </li>
                                      <li className="list-group-item px-0 d-flex justify-content-between">
                                        <span>Property Tax</span>
                                        <span className="fw-bold">
                                          $
                                          {Math.round(
                                            (property.TaxAnnualAmount || 3600) /
                                              12,
                                          )}
                                        </span>
                                      </li>
                                      <li className="list-group-item px-0 d-flex justify-content-between">
                                        <span>Insurance</span>
                                        <span className="fw-bold">$100.00</span>
                                      </li>
                                      <li className="list-group-item px-0 d-flex justify-content-between">
                                        <span>HOA Fees</span>
                                        <span className="fw-bold">
                                          ${property.AssociationFee || 0}
                                        </span>
                                      </li>
                                      <li className="list-group-item px-0 d-flex justify-content-between">
                                        <span>Utilities</span>
                                        <span className="fw-bold">$250.00</span>
                                      </li>
                                      <li className="list-group-item px-0 d-flex justify-content-between">
                                        <span className="fw-bold">
                                          Total Monthly Cost
                                        </span>
                                        <span className="fw-bold text-dark">
                                          $2,075.00
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>

            {/*  */}
            <div fluid className="p-3 bg-white rounded shadow-sm">
              {/* Legal Description */}
              <div className="border-bottom pb-2 mb-3">
                <h6 className="fw-bold">Legal Description</h6>
                <p className="mb-0 text-muted">
                  {property.LegalDescription || "N/A"}
                </p>
              </div>

              {/* Building Section */}
              <div className="border-bottom pb-3 mb-3">
                <h6 className="fw-bold mb-3">Building</h6>

                <div className="mb-3">
                  <strong>Bathrooms</strong>
                  <p className="mb-0 text-muted">
                    Total: {property.BathroomsTotalInteger || "N/A"}
                  </p>
                </div>

                <div className="mb-3">
                  <strong>Interior Features</strong>
                  <p className="mb-0 text-muted">
                    Basement Type: {property.BasementYN || "N/A"}
                  </p>
                </div>

                <div className="mb-3">
                  <strong>Building Features</strong>
                  <Row>
                    <Col md={4}>
                      <div>
                        <span className="fw-bold d-block">Features</span>
                        <span className="text-muted">N/A</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div>
                        <span className="fw-bold d-block">Style</span>
                        <span className="text-muted">N/A</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div>
                        <span className="fw-bold d-block">
                          Architecture Style
                        </span>
                        <span className="text-muted">
                          {property.ArchitectureStyle || "N/A"}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="mb-3">
                  <strong>Heating & Cooling</strong>
                  <p className="mb-0 text-muted">
                    Heating Type: {property.HeatingExpenses || "N/A"}
                  </p>
                </div>

                <div className="mb-0">
                  <strong>Parking</strong>
                  <p className="mb-0 text-muted">N/A</p>
                </div>
              </div>

              {/* Measurements */}
              <div className="border-bottom pb-2 mb-3">
                <h6 className="fw-bold">Measurements</h6>
                <p className="mb-0 text-muted">
                  Square Footage: {property.SquareFootage || "N/A"} sqft
                </p>
              </div>

              {/* Rooms */}
              <div>
                <h6 className="fw-bold mb-3">Rooms</h6>
                <Row className="bg-light py-2 fw-bold border-bottom">
                  <Col md={4}>Level</Col>
                  <Col md={4}>Room</Col>
                  <Col md={4}>Measurement</Col>
                </Row>
                {property.Rooms && property.Rooms.length > 0 ? (
                  property.Rooms.map((room, index) => (
                    <Row key={index} className="py-2 border-bottom">
                      <Col md={4}>N/A</Col>
                      <Col md={4}>{room.ParkingFeatures || "N/A"}</Col>
                      <Col md={4}>N/A</Col>
                    </Row>
                  ))
                ) : (
                  <Row className="py-2">
                    <Col>No room details available.</Col>
                  </Row>
                )}
              </div>
            </div>
            <div fluid className="p-3 bg-white rounded shadow-sm mt-4">
              {/* Legal Description */}
              <div className="border-bottom pb-2 mb-3">
                <h6 className="fw-bold">Client Review</h6>
                <p className="mb-0 text-muted">
                  {property.PublicRemarks || "N/A"}
                </p>
              </div>
            </div>
          </Col>

          {/* Sidebar / Contact Form */}
          <Col lg={4}>
            <div className="sticky-top" style={{ top: "20px" }}>
              <Card className="shadow-sm border-0 mb-4">
                <Card.Body className="p-4">
                  <h4 className="text-dark fw-bold text-center mb-4">
                    Contact an Agent
                  </h4>

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Your Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="py-2"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="email"
                        placeholder="Your Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="py-2"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="tel"
                        placeholder="Phone Number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="py-2"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="I'm interested in this property..."
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        className="py-2"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Check
                        type="checkbox"
                        label="Schedule a viewing"
                        name="scheduleViewing"
                        checked={formData.scheduleViewing}
                        onChange={handleChange}
                      />
                    </Form.Group>

                    {showDateTimeFields && (
                      <div className="mb-3">
                        <Row className="g-2">
                          <Col sm={6}>
                            <Form.Group>
                              <Form.Label className="small text-muted">
                                Preferred Date
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="preferredDate"
                                value={formData.preferredDate}
                                onChange={handleChange}
                                className="py-2"
                              />
                            </Form.Group>
                          </Col>
                          <Col sm={6}>
                            <Form.Group>
                              <Form.Label className="small text-muted">
                                Preferred Time
                              </Form.Label>
                              <Form.Control
                                type="time"
                                name="preferredTime"
                                value={formData.preferredTime}
                                onChange={handleChange}
                                className="py-2"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    )}

                    <button type="submit" className="btn btn-dark px-4 w-100">
                      Submit Request
                    </button>
                  </Form>
                </Card.Body>
              </Card>

              <Card className="shadow-sm border-0">
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-3">Need Financing?</h5>
                  <p className="text-muted small">
                    Get pre-approved and calculate your monthly mortgage
                    payments.
                  </p>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-dark px-4 w-100">
                      Calculate Mortgage
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PropertyDetails;
